import React from 'react';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

GlobalWorkerOptions.workerSrc = pdfjsWorker;

function generatePDFThumbnail(page) {
  const scale = 1;
  const viewport = page.getViewport({ scale });
  const canvas = window.document.createElement('canvas');
  canvas.width = viewport.width * scale;
  canvas.height = viewport.height * scale;
  return page.render({
    canvasContext: canvas.getContext('2d'),
    viewport: page.getViewport({ scale: scale })
  })
    .promise.then(() => canvas);
}

/**
 * @param {string | ArrayBuffer} src 
 * @param {() => void} callback 
 */
function getThumbnailFromSrc(src, callback) {
  getDocument(src)
    .promise.then((document) => {
      document.getPage(1)
        .then(generatePDFThumbnail)
        .then((canvas) => {
          const element = (
            <img
              style={{ borderRadius: 4 }}
              width={60}
              height={60}
              src={canvas.toDataURL()}
            />
          );
          callback({ default: element });
        })
    });
}

/**
 * @param {File} file 
 * @returns {Promise<{default: React.ReactElement}>}
 */
export function getFileThumbnail(file) {
  return new Promise((resolve, reject) => {
    if (file instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64FileContent = reader.result;
        getThumbnailFromSrc(base64FileContent, resolve);
      }
      reader.onerror = (error) => {
        reject(error);
      }
    } else {
      getThumbnailFromSrc(file, resolve);
    }
  });
}

/**
 * @param {File} file 
 * @returns {Promise<{default: React.ReactElement}>}
 */
export function getFileType(filename) {
  let fileType = 'image';
  const supportedVideoExtenstions = ['mp4', 'mov'];
  if(filename){
    const fileExtension = filename.split('.').at(-1).toLowerCase();
    if(fileExtension === 'pdf'){
      fileType ='application/pdf';
    }
    else if(supportedVideoExtenstions.indexOf(fileExtension) >=0){
      fileType ='video/mp4'
    }
  }
  return fileType;
}

/**
 * Add timestamp to filename
 * @param filename string 
 * @param maxFilenameLength number 
 * @returns {string}
 */
export const getTimestampedFileName = (filename, maxFilenameLength) => {
  const extension = '.' + filename.split('.').at(-1);
  const stampedfileLength = 1 + getTimeStamp().length + extension.length;
  let nameWithoutExt = filename.slice(0, filename.length - extension.length);


  if (maxFilenameLength && maxFilenameLength > stampedfileLength) {
    nameWithoutExt = nameWithoutExt.slice(0, maxFilenameLength - stampedfileLength);
  }
  const stamp = getTimeStamp();
  const newFileName = nameWithoutExt
    ? `${nameWithoutExt}_${stamp}${extension}`
    : stamp + extension
  return newFileName;
}

const createBlobAndDownload = (responseData, fileName) => {
  const decodedData = new Uint8Array(responseData);
  const url = window.URL.createObjectURL(new Blob([decodedData]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

const getTimeStamp = () => {
  return new Date().toISOString().replace(/[-T:Z.]/g, '');
}

export default createBlobAndDownload;
